<template>
  <img src="../../assets/img/left-arrow.png" />
</template>